import { Validate } from "react-hook-form";

const validateSSN: Validate<string, undefined> = (ssn: string) => {
  const errorKey = "ssnIsWrong";

  if (ssn.length < 11) return false;
  const ssnSplit = ssn?.split(/[-ABCDEFYXWVU]/);
  const ssnSeparators1900 = "-YXWVU";
  const ssnSeparators2000 = "ABCDEF";
  const ssnSeparatorValue = ssn?.substring(6, 7).toString() ?? "";
  const ssnCheckMarkValue = ssn?.substring(10, 11).toString() ?? "";
  const checkMarks = "0123456789ABCDEFHJKLMNPRSTUVWXY";
  const DD = parseInt(ssn?.substring(0, 2) ?? "");
  const MM = parseInt(ssn?.substring(2, 4) ?? "");
  const year = ssn?.substring(4, 6);
  let yearCheck: number | undefined;
  let calculatedCheckMark;
  const yearCheck1900 = year ? parseInt(year, 10) + 1900 : undefined;
  const yearCheck2000 = year ? parseInt(year, 10) + 2000 : undefined;

  const splitIsValid =
    ssnSeparatorValue &&
    (ssnSeparators1900.includes(ssnSeparatorValue) ||
      ssnSeparators2000.includes(ssnSeparatorValue));
  if (!splitIsValid || !ssn.trim() || ssn.length > 11) return errorKey;

  if (splitIsValid) {
    if (
      yearCheck1900 &&
      yearCheck1900 < 2000 &&
      ssnSeparators1900.includes(ssnSeparatorValue)
    ) {
      // use only 1900-century separatormarks, if yearCheck is under 2000 and ssnSeparatorvalue includes in 1900-century separator values
      yearCheck = yearCheck1900;
    } else if (
      yearCheck2000 &&
      yearCheck2000 >= 2000 &&
      ssnSeparators2000.includes(ssnSeparatorValue)
    ) {
      // use only 2000-century separatormarks, if yearCheck is the 2000 or bigger and ssnSeparatorvalue includes in 2000-century separator values
      yearCheck = yearCheck2000;
    } else {
      // Separator value or yearcheck is undefined
      yearCheck = undefined;
    }
  }

  const leapYear = yearCheck && yearCheck % 4 === 0;

  // Validate the day based on the month
  const daysInMonth = [
    31,
    leapYear ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  if (DD < 1 || DD > daysInMonth[MM - 1] || MM < 1) {
    return errorKey;
  }

  if (splitIsValid && yearCheck) {
    const ssnNumbers = parseInt(ssnSplit[0] + ssnSplit[1].substring(0, 3));
    const checkMarkForSSN = ssnNumbers % 31;
    calculatedCheckMark = checkMarks.charAt(checkMarkForSSN);

    if (
      calculatedCheckMark &&
      !calculatedCheckMark.includes(ssnCheckMarkValue)
    ) {
      return errorKey;
    }
  }
  return true;
};

export default validateSSN;
